module.exports = __webpack_public_path__ + "img/MEDIA009.93d83f76.jpg";